import { render, staticRenderFns } from "./SearchPageContent.vue?vue&type=template&id=5c460596&scoped=true&"
import script from "./SearchPageContent.vue?vue&type=script&lang=js&"
export * from "./SearchPageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c460596",
  null
  
)

export default component.exports